<template>
    <div class="list">
        <div class="list-container">
            <div class="logo">
            </div>
            <div class="title">
                直播列表
            </div>
            <div class="content-divide"></div>
            <div v-if="noData" style="width: 100%; height: 50px; text-align: center;padding: 15px; font-size: 20px;color: #B3B3B3;">暂时没有可观看的直播</div>
            <div class="infinite-list-wrapper" style="overflow:auto">
                <ul class="list-wrapper" v-infinite-scroll="getLives" infinite-scroll-disabled="disabled">
                    <div v-for="i in count" class="list-item-container">
                        <div class="item-cover-img">
                            <img v-if="list.length>0" alt="" :src="list[i-1].play"/>
                        </div>
                        <div class="item-info">
                            <div class="title">{{ list[i-1].name }}</div>
                            <div class="item-data" first-child>{{ '开始时间：'+list[i-1].startTime  }}</div>
                            <div class="item-data">{{ '结束时间：'+list[i-1].endTime  }}</div>
                            <div class="item-data">{{ '当前状态：'+stateMap[list[i-1].liveStatus]  }}</div>
                            <!-- <div style="display: none;">{{ getLiveStatus(list[i-1])}}</div> -->
                            <!-- <div class="item-button" :status="`${list[i-1].liveStatus}`" > -->
                            <div class="item-button">
                                <el-button @click="goDetail(list[i-1].liveId)" >观看直播</el-button>
                            </div>
                        </div>
                    </div>
                </ul>
                <p v-if="loading">加载中...</p>
                <p v-if="noMore">没有更多了</p>
            </div>
        </div>
    </div>
</template>
    
<script>
export default {
    data: () => {
        return {
            current: 1,
            list: [],
            stateMap: {
                0: '未开始',
                1: '进行中',
                2: '已结束'
            },
            liveId: 0,
            poster: null,
            liveStatus: 0,
            showPosterDialog: false,
            total: 1,
            count: 0,
            loading: false,
            noData: false,
            // timer: {}
        };
    },
    computed: {
        noMore() {
            return this.count >= this.awardTotal
        },
        disabled() {
            return this.loading || this.noMore
        }
    },
    mounted() {
    },
    // destroyed(){
    //     console.log(this.timer)
    //     Object.keys(this.timer).forEach(i=>clearTimeout(this.timer[i]))
    // },
    methods: {
        // getLiveStatus: async function (item) {
        //     let that = this;
        //     let resp = await this.$action.live.getLiveStatus(item.liveId);
        //     item.liveStatus = resp
        //     if (!this.timer[item.liveId+'']) {
        //         this.timer[item.liveId+''] = setTimeout(function () {
        //             that.getLiveStatus(item)
        //             that.timer[item.liveId+''] = null
        //         }, 5000)
        //     }
        // },
        getLives: async function () {
            if (this.count >= this.total) return;
            this.loading = true;
            let resp = await this.$action.live.getLiveList(this.current);
            let liveList = resp ? resp.list : []
            this.list = this.list.concat(liveList);
            this.total = resp.total || 0;

            if (liveList.length > 0) {
                this.count += liveList.length;
            }
            if(!this.noMore){
                this.current++;
            }

            if(this.total == 0){
                this.noData = true;
            }

            this.loading = false;
        },
        showPoster: function (item) {
            this.liveId = item.liveId;
            this.poster = item.poster;
            this.liveStatus = item.liveStatus;
            this.showPosterDialog = true;
        },
        goDetail: function (liveId) {
            this.$router.push({ path: '/live/detail', query: { liveId } });
        }
    },
}
</script>
<style scoped>
.list {
    height: 100vh;
    width: 100vw;
    display: flex;
    background-color: white;
    justify-content: center;
    align-items: center;
    background-image: url('../../../static/image/common/background-water.png');
    background-size: contain;
}

.list .list-container {
    margin: auto;
    width: 1150px;
    min-height: 100vh;
}

.list-container .logo {
    margin-top: 40px;
    width: 100px;
    height: 36px;
    background-image: url('../../../static/image/common/Nike-logo-2@2x.png');
    background-size: cover;
}

.list-container .title {
    margin-top: 11px;
    width: 128px;
    height: 45px;
    font-size: 32px;
    color: #111111;
    font-weight: bold;
}

.list-container .content-divide {
    margin: 11px 0;
    border: 1px solid #111111;
}

/* .list-container .list-wrapper {
    width: 1140px;
    margin-block-start: 0px !important;
    margin-block-end: 0px !important;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0px !important;
} */

.infinite-list-wrapper{
    padding: 0 5px;
    height: calc(100vh - 176px);
}

.infinite-list-wrapper::-webkit-scrollbar{
    width: 4px;
    height: 0px;
}

.infinite-list-wrapper::-webkit-scrollbar::-webkit-scrollbar-thumb{
    background-color: #c0c4cc;
}
.infinite-list-wrapper p{
    text-align: center;
    font-size: 18px;
}
.list-wrapper .list-item-container{
    margin-top: 20px;
    width: 1140px;
    height: 281px;
    background-color: white;
    box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.3);
    position: relative;
}

.list-item-container .item-cover-img{
    position: absolute;
    top: 0;
    left: 0;
    width: 500px;
    height: 281px;
    box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.3);
}
.list-item-container .item-cover-img img{
    width: 500px;
    height: 281px;
}

.list-item-container .item-info{
    position: absolute;
    top: 0;
    left: 500px;
    width: 640px;
    height: 281px;
    padding: 20px;
}

.item-info .title{
    width: 600px;
    height: 31px;
    font-size: 26px;
    line-height: 28px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.item-info .item-data{
    margin-top: 10px;
    width: 600px;
    height: 22px;
    font-size: 16px;
    color: #888888;
    line-height: 28px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.item-data[first-child]{
    margin-top: 20px;
}

.item-info .item-button button{
    margin-top: 40px;
    width: 185px;
    height: 40px;
    background-color: #111111;
    color: #fff;
    font-size: 16px;
}

.item-info .item-button[status='1'] button{
    background-color: #111111;
}
</style>


// WEBPACK FOOTER //
// src/pages/live/list.vue